import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "antd";
import UserIcon from "../../../../../assets/images/analytics-user.png";
import UsersIcon from "../../../../../assets/images/analytics-users.png";
import CompanyIcon from "../../../../../assets/images/analytics-company.png";
import OrgIcon from "../../../../../assets/images/analytics-org.png";
import PDFIcon from "../../../../../assets/images/pdf.png";
import CsvIcon from "../../../../../assets/images/csv.png";
import http from "../../../../../services/http";
import { ExitToApp } from "@mui/icons-material";

function GlobalAnalytics() {
  const [data, setData] = useState({});

  const getGlobalAnalytics = async () => {
    const { data } = await http.get(`global-analytics`);
    setData(data);
  };

  useEffect(async () => {
    getGlobalAnalytics();
  }, []);

  return (
    <>
      <Row gutter={[18, 18]}>
        <Col xs={24} lg={6}>
          <Card className="analytics-card thumb">
            <div className="thumbnail">
              <img src={UserIcon} style={{ width: 30 }} alt="" />
            </div>
            <div className="detail">
              <h3>Total Users</h3>
              <h1>{data?.totalUsers}</h1>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={6}>
          <Card className="analytics-card thumb">
            <div className="thumbnail">
              <img src={UsersIcon} alt="" />
            </div>
            <div className="detail">
              <h3>Total Users logged</h3>
              <h1>{data?.usersLoggedInThisWeek}</h1>
              <p className="tagline">In this week</p>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={6}>
          <Card className="analytics-card thumb">
            <div className="thumbnail">
              <img src={CompanyIcon} alt="" />
            </div>
            <div className="detail">
              <h3>Total Companies</h3>
              <h1>{data?.totalCompanies}</h1>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={6}>
          <Card className="analytics-card thumb">
            <div className="thumbnail">
              <img src={OrgIcon} alt="" />
            </div>
            <div className="detail">
              <h3>Total Organizations</h3>
              <h1>{data?.organizations}</h1>
            </div>
          </Card>
        </Col>
      </Row>
      <Row gutter={[18, 18]} style={{ marginTop: 20 }}>
        <Col xs={24} lg={8}>
          <Card className="analytics-card">
            <h3>Florence downloads</h3>
            <h1>{data?.buyersCsv + data?.buyersPDF + data?.buyerCRMExport}</h1>
            <div className="download-stats">
              <div className="box">
                <img src={PDFIcon} alt="" />
                <div className="detail">
                  <h4>{data?.buyersPDF}</h4>
                  <p>Downloads</p>
                </div>
              </div>
              <div className="box">
                <img src={CsvIcon} alt="" />
                <div className="detail">
                  <h4>{data?.buyersCsv}</h4>
                  <p>Downloads</p>
                </div>
              </div>
              <div className="box">
                <span className="thumb">
                  <ExitToApp />
                </span>
                <div className="detail">
                  <h4>{data?.buyerCRMExport}</h4>
                  <p>Downloads</p>
                </div>
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={8}>
          <Card className="analytics-card">
            <h3>Leads downloads</h3>
            <h1>{data?.leadsCsv + data?.leadsPDF + data?.leadsCRMExport}</h1>
            <div className="download-stats">
              <div className="box">
                <img src={PDFIcon} alt="" />
                <div className="detail">
                  <h4>{data?.leadsPDF}</h4>
                  <p>Downloads</p>
                </div>
              </div>
              <div className="box">
                <img src={CsvIcon} alt="" />
                <div className="detail">
                  <h4>{data?.leadsCsv}</h4>
                  <p>Downloads</p>
                </div>
              </div>
              <div className="box">
                <span className="thumb">
                  <ExitToApp />
                </span>
                <div className="detail">
                  <h4>{data?.leadsCRMExport}</h4>
                  <p>Downloads</p>
                </div>
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={8}>
          <Card className="analytics-card">
            <h3>Investor search downloads</h3>
            <h1>{data?.investorCsv + data?.investorPDF + data?.investorCRMExport}</h1>
            <div className="download-stats">
              <div className="box">
                <img src={PDFIcon} alt="" />
                <div className="detail">
                  <h4>{data?.investorPDF}</h4>
                  <p>Downloads</p>
                </div>
              </div>
              <div className="box">
                <img src={CsvIcon} alt="" />
                <div className="detail">
                  <h4>{data?.investorCsv}</h4>
                  <p>Downloads</p>
                </div>
              </div>
              <div className="box">
                <span className="thumb">
                  <ExitToApp />
                </span>
                <div className="detail">
                  <h4>{data?.investorCRMExport}</h4>
                  <p>Downloads</p>
                </div>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default GlobalAnalytics;
